import { IInsuranceContract, PricingModelType, ProductGroupType } from '@alberta/konexi-shared';

import { BaseProductGroupViewModel } from './base-product-group-view-model';

export class TreeProductGroupViewModel extends BaseProductGroupViewModel {
  public setBillingType(contracts: IInsuranceContract[]): any {
    if (this.type !== ProductGroupType.TWG) {
      return;
    }
    this.billing = 'UBK';
    this.possibleContracts = [];

    if (contracts) {
      this.setContracts(contracts);
      if (this.possibleContracts && this.possibleContracts.length > 0) {
        const firstContract = this.possibleContracts[0];
        this.billing = firstContract.isSelfPayer ? 'SZ' : 'KT';
      }
    }
  }

  public setAllContractAreFlatCharge(contracts: IInsuranceContract[] | undefined): any {
    if (this.type !== ProductGroupType.TWG) {
      return;
    }
    this.possibleContracts = [];
    if (contracts) {
      this.setContracts(contracts);
      this.allContractsAreFlatCharge =
        this.possibleContracts.length &&
        this.possibleContracts.every(contract => contract.pricingModelType === PricingModelType.FlatCharge);
    }
  }

  public hideGeneralContracts() {
    // only show general contracts if there are no other contracts
    if (this.possibleContracts?.length) {
      const contracts = this.possibleContracts.filter(contract => !contract.generalContract);
      if (contracts?.length) {
        this.possibleContracts = contracts;
      }
    }
  }

  private setContracts(contracts: IInsuranceContract[]): any {
    if (contracts?.length) {
      for (const possibleContract of contracts) {
        if (possibleContract.maximumAmountForProductGroups.find(ma => ma.productGroupId === this._id)) {
          this.possibleContracts.push(possibleContract);
        }
      }
    }
  }
}
